import tmobileImg from '../img/brand/T-Mobile_Logo.png';
import attImg from '../img/brand/att-logo.png';
import juiceImg from '../img/brand/Juice-logo.png';
import syracuseSingle from '../img/brand/Syracuse_University_1.png';
import syracuseMultipe from '../img/brand/Syracuse_University_2.png';
import caesarsImg from '../img/brand/caesars-nobu.png';
import jmaImg from '../img/JMA_Logo_RGB_MASTER.svg';
import moment from 'moment-timezone';
import { getAuthHeaders } from './authHeaders';
import { combineCSVReports, prepareCSVReport } from './comparisonCsv';

const colorMap = {
  Critical: "#F07162",
  Major: "#FC9D2B",
  Warning: "#5482B3",
  Unacknowledged: "#333840",
  Minor: "#F8D36A",
  Informational: "#A9B2BD",
  "All": "#333840",
};

const imageMapping = {
  'T-Mobile': tmobileImg,
  'AT&T': attImg,
  'Juice': juiceImg,
  'syracyse': syracuseSingle,
  'syracuse-multiple': syracuseMultipe,
  'caesars': caesarsImg,
  'Private': juiceImg,
  'JMA': jmaImg,
  'jmahq': jmaImg
};

export const getColorByName = (name) => {
  const formattedName = name.replaceAll("Alarms", "").trim();
  return colorMap[formattedName] || null;
}

export const getAlarmName = (name) => {
  const formattedName = name.replaceAll("Alarms", "").trim();
  return formattedName;
}

export const formatDateRange = (dateObj) => {
  if (dateObj && dateObj?.start?._d && dateObj?.end?._d) {
    const startDate = dateObj?.start?._d;
    const endDate = dateObj?.end?._d;

    // Helper to format a single date (e.g., 7-NOV-2025)
    const formatDate = (date) => {
      const day = date.getDate(); // No zero padding
      const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    };

    // Normalize start and end for comparison
    const normStart = new Date(startDate);
    normStart.setHours(0, 0, 0, 0);
    const normEnd = new Date(endDate);
    normEnd.setHours(0, 0, 0, 0);

    if (normStart.getTime() === normEnd.getTime()) {
      return formatDate(startDate);
    }

    // Otherwise, return the full range
    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);
    return `${formattedStart} - ${formattedEnd}`;
  } else {
    return "";
  }
};

// export const formatDateTimeForDBQuery = (dateObj) => {
//   const startDate = dateObj.start._d;
//   const endDate = dateObj.end._d;

//   // Helper function to format date with time
//   const formatDateTime = (date, isEndOfDay = false) => {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');

//     const time = isEndOfDay ? '08%3A00%3A00' : '05%3A00%3A00';

//     return `${year}-${month}-${day} ${time}`;
//   };

//   return {
//     start: formatDateTime(startDate, false),
//     end: formatDateTime(endDate, true)
//   };
// }

export const convertToTimezoneMidnightUtc = (date, tz) => {
  return moment.tz(date, tz).startOf("day").utc();
};

/**
 * @param {moment|string|Date} date - The selected calendar date
 * @param {string} tz - IANA tz string ("America/New_York" or "America/Los_Angeles")
 * @returns {moment} UTC moment for selected date, set to 04:00:00 EST or 07:00:00 PST as required
 */
export const setFixedTimeAndConvertToUtc = (date, tz) => {
  // For EST (America/New_York) use 04:00:00, for PST use 07:00:00, otherwise fallback to 00:00:00.
  let fixedTime = "00:00:00";
  if (tz === "America/New_York") fixedTime = "04:00:00";
  else if (tz === "America/Los_Angeles") fixedTime = "07:00:00";
  // Make a moment in that tz, set the time as desired, then convert to UTC representation
  const dateStr = moment(date).format("YYYY-MM-DD") + " " + fixedTime;
  return moment.tz(dateStr, "YYYY-MM-DD HH:mm:ss", tz).utc();
}


export const formatDateTimeForDBQuery = (dateObj, tabLabel) => {
  const tz =
    tabLabel === 0
      ? "America/New_York"
      : tabLabel === 1
        ? "America/Los_Angeles"
        : "America/New_York";

  // Selected values are UTC instants fixed to the tz's 04:00/07:00; read back the calendar date in that tz.
  const fmt = (d) => moment.tz(d, tz).format("YYYY-MM-DD");

  // Inclusive calendar dates, sent directly as start_date / end_date
  return {
    start: fmt(dateObj.start),
    end: fmt(dateObj.end),
  };
};
export const transformAPIResponseForTable = (responseData) => {
  // Define carrier name mappings
  const carrierMapping = {
    'TMO': 'T-Mobile',
    'ATT': 'AT&T',
    'Juice': 'Juice'
  };

  if (!responseData) {
    return [];
  }
  // Transform the data into flat array format
  const tableData = Object?.keys(responseData).map((key) => {
    // Handle both array and object structures
    const carrierData = Array.isArray(responseData[key])
      ? responseData[key][0]
      : responseData[key];

    return {
      name: carrierMapping[key] || key,
      userCount: carrierData['User Count'][0],
      upload: bytesToGB(carrierData['Tx Data'][0]),
      download: bytesToGB(carrierData['Rx Data'][0])
    };
  });

  return tableData;
}

export const getTotalRow = (tableData) => {
  if (tableData && tableData?.length > 0) {


    // Calculate totals
    const totals = tableData?.reduce((acc, row) => {
      return {
        userCount: acc.userCount + Number(row.userCount),
        upload: acc.upload + Number(row.upload),
        download: acc.download + Number(row.download),
        live: acc.live + Number(row.live),
        yesterday: acc.yesterday + Number(row.yesterday),
      };
    }, { userCount: 0, upload: 0, download: 0, live: 0, yesterday: 0 });

    // Create total row
    const totalRow = {
      name: "Total",
      userCount: totals?.userCount.toString(),
      upload: parseFloat(totals?.upload).toFixed(2),
      download: parseFloat(totals?.download).toFixed(2),
      live: totals?.live.toString(),
      yesterday: totals?.yesterday.toString()
    };

    // Return new array with total row appended
    return totalRow;
  } else {
    return {
      name: "Total",
      userCount: "0",
      upload: "0",
      download: "0",
      live: "0",
      yesterday: "0"
    }
  }
}

export const bytesToGB = (bytes) => {
  if (bytes)
    return (Number(bytes) / (1024 ** 3)).toFixed(2);
  else
    return bytes;
};

export const getImagePath = (carrierName, universityName) => {
  if (["caesars", "jmahq"].includes(universityName?.toLowerCase()) && carrierName?.toLowerCase() === "private") {
    return imageMapping['JMA'];
  } else {
    return imageMapping[carrierName] || 'src/img/brand/default.png';
  }
}

export const getLiveDataTransformResponse = (apiResponse) => {
  const carriers = ['AT&T', 'T-Mobile', 'Private'];
  if (!apiResponse) {
    return;
  }
  const transformedData = carriers.map((carrier) => {
    const carrierKey = carrier;

    const dailyData = apiResponse.Daily[carrierKey] || {};
    const cumulativeData = apiResponse.Combined[carrierKey] || {};
    const liveData = apiResponse.Live[carrierKey] || {};

    const rxKey = Object.keys(cumulativeData).find(key => key.includes('Rx'));
    const download = cumulativeData[rxKey];

    const txKey = Object.keys(cumulativeData).find(key => key.includes('Tx'));
    const upload = cumulativeData[txKey];

    const cumulativeUserKey = Object.keys(cumulativeData).find(key => key.includes('Users'));
    const userCount = cumulativeData[cumulativeUserKey] || '';

    const dailyUserKey = Object.keys(dailyData).find(key => key.includes('Users'));
    const yesterday = dailyData[dailyUserKey] || '';

    const liveUserKey = Object.keys(liveData).find(key => key.includes('Users'));
    const live = liveData[liveUserKey] || '';

    return {
      name: carrier,
      userCount: userCount,
      upload: bytesToGB(upload || 0),
      download: bytesToGB(download || 0),
      live: live,
      yesterday: yesterday
    };
  });

  return transformedData;
}

export const getNewLiveDataTransformResponse = (apiArray) => {


  const carriers = ["AT&T", "T-Mobile", "Private"];

  if (!apiArray || !Array.isArray(apiArray)) return [];

  // Step 1: Rearrange flat API array into grouped object
  const groupedData = {
    Daily: { "AT&T": {}, "T-Mobile": {}, Private: {}, Combined: {} },
    Combined: { "AT&T": {}, "T-Mobile": {}, Private: {}, Combined: {} },
    Live: { "AT&T": {}, "T-Mobile": {}, Private: {}, Combined: {} },
  };

  apiArray.forEach((item) => {
    const name = item.name;
    const value = item.lastvalue;

    // DAILY
    if (name.includes("Daily")) {
      if (name.includes("AT&T")) groupedData.Daily["AT&T"][name] = value;
      else if (name.includes("T-Mobile")) groupedData.Daily["T-Mobile"][name] = value;
      else if (name.includes("Private")) groupedData.Daily["Private"][name] = value;
      else groupedData.Daily["Combined"][name] = value;
    }

    // CUMULATIVE / COMBINED
    if (name.includes("Cumulative")) {
      if (name.includes("AT&T")) groupedData.Combined["AT&T"][name] = value;
      else if (name.includes("T-Mobile")) groupedData.Combined["T-Mobile"][name] = value;
      else if (name.includes("Private")) groupedData.Combined["Private"][name] = value;
      else groupedData.Combined["Combined"][name] = value;
    }

    // LIVE
    if (name.includes("Live")) {
      if (name.includes("AT&T")) groupedData.Live["AT&T"][name] = value;
      else if (name.includes("T-Mobile")) groupedData.Live["T-Mobile"][name] = value;
      else if (name.includes("Private")) groupedData.Live["Private"][name] = value;
      else groupedData.Live["Combined"][name] = value;
    }
  });

  // Step 2: Convert grouped data to your original transformed format
  const transformedData = carriers.map((carrier) => {
    const dailyData = groupedData.Daily[carrier] || {};
    const cumulativeData = groupedData.Combined[carrier] || {};
    const liveData = groupedData.Live[carrier] || {};

    const rxKey = Object.keys(cumulativeData).find((key) => key.includes("Rx"));
    const download = cumulativeData[rxKey];

    const txKey = Object.keys(cumulativeData).find((key) => key.includes("Tx"));
    const upload = cumulativeData[txKey];

    const cumulativeUserKey = Object.keys(cumulativeData).find((key) => key.includes("Users"));
    const userCount = cumulativeData[cumulativeUserKey] || "";

    const dailyUserKey = Object.keys(dailyData).find((key) => key.includes("Users"));
    const yesterday = dailyData[dailyUserKey] || "";

    const liveUserKey = Object.keys(liveData).find((key) => key.includes("Users"));
    const live = liveData[liveUserKey] || "";

    // ✅ NEW: VoLTE from daily data for this carrier
    const volteKey = Object.keys(dailyData).find((key) =>
      key.toLowerCase().includes("volte")
    );
    const volte = dailyData[volteKey] || "";

    return {
      name: carrier,
      userCount: userCount,
      upload: bytesToGB(upload || 0),
      download: bytesToGB(download || 0),
      live: live,
      yesterday: yesterday,
      volte: volte,
    };
  });

  return transformedData;
};

export const extractVoLTECalls = (apiArray) => {
  if (!apiArray || !Array.isArray(apiArray)) return null;

  const volteItem = apiArray.find(item => item.name === "Daily VoLTE Calls");
  return volteItem ? volteItem.lastvalue : null;
};


export const extractVoLTEFromObject = (apiData) => {
  if (!apiData || typeof apiData !== 'object') return null;

  // For date range, VoLTE is directly in the object
  return apiData.VoLTE || null;
};

export const getDateRangeDataTransformResponse = (apiResponse) => {
  const carriers = ['AT&T', 'T-Mobile', 'Private'];

  if (!apiResponse || typeof apiResponse !== 'object') {
    return [];
  }

  return carriers.map((carrier) => {
    const keyMap = {
      'AT&T': 'ATT',
      'T-Mobile': 'TMO',
      'Private': 'Private',
    };
    const prefix = keyMap[carrier];

    let volte = apiResponse[`${prefix}_Volte`];
    if(!volte){
      volte = apiResponse[`${prefix}_VoLTE`] ?? 0;
    }

    const userCount = apiResponse[`${prefix}_Users`] ?? 0;
    const download = apiResponse[`${prefix}_RX`] ?? 0;   // RX = download
    const upload = apiResponse[`${prefix}_TX`] ?? 0;     // TX = upload
    // const volte = apiResponse[`${prefix}_Volte`] ?? 0;   // Add VoLTE count

    return {
      name: carrier,
      userCount,
      upload: bytesToGB(upload),
      download: bytesToGB(download),
      volte,                          // Add volte field
      live: userCount,                // live = current user count for the range
      yesterday: '',                  // yesterday not available in range payload
    };
  });
};


/**
 * Extract roles (group names) from Keycloak token (realm_access.roles array).
 * @param {object} tokenResponse - Token or tokenParsed object with realm_access
 * @returns {string[]} Array of roles/groups, or [] if not present
 */
export function extractRealmRoles(tokenResponse) {
  if (
    tokenResponse &&
    tokenResponse.realm_access &&
    Array.isArray(tokenResponse.realm_access.roles)
  ) {
    return tokenResponse.realm_access.roles;
  }
  return [];
}

/**
 * Format a number with commas as thousands separator.
 * @param {number|string} num - The number to format.
 * @returns {string}
 */
export function formatNumberWithCommas(num) {
  if (num === null || num === undefined) return '';
  const n = Number(num);
  if (isNaN(n)) return '';
  return n.toLocaleString('en-US');
}

export const formatChipFontColorAvaliability = (value) => {
  if (value >= 99) {
    return "#388E3C";
  } else if (value < 99 && value >= 90) {
    return "#f18740ff";
  } else {
    return "#F44336";
  }
}

export const formatChipBgColorAvaliability = (value) => {
  if (value >= 99) {
    return "#E8F5E9";
  } else if (value < 99 && value >= 90) {
    return "#f3d7b8ff";
  } else {
    return "#FFEBEE";
  }
}

export const downloadCSV = async (sUrl, site, selectedDates) => {
  const headers = await getAuthHeaders();
  const response = await fetch(sUrl, {
    headers,
  });
  const responseCSV = await response.text();
  const csv = prepareCSVReport({ csv: responseCSV, dates: selectedDates });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `network_report_${site}_${formatDateRange(selectedDates)}.csv`;
  link.click();

  URL.revokeObjectURL(url);
};

export const downloadComparisonCSV = async ({ firstUrl, secondUrl, site, firstDates, secondDates }) => {
  const headers = await getAuthHeaders();
  const [firstResponse, secondResponse] = await Promise.all([
    fetch(firstUrl, { headers }),
    fetch(secondUrl, { headers }),
  ]);

  if (!firstResponse.ok || !secondResponse.ok) {
    throw new Error('Unable to download one or more comparison reports.');
  }

  const [firstCSV, secondCSV] = await Promise.all([
    firstResponse.text(),
    secondResponse.text(),
  ]);
  const csv = combineCSVReports({
    firstCSV,
    secondCSV,
    firstDates,
    secondDates,
  });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const safeRange = (dates) => formatDateRange(dates).replace(/[^A-Za-z0-9-]+/g, '_');
  const link = document.createElement('a');
  link.href = url;
  link.download = `network_report_${site}_${safeRange(firstDates)}_vs_${safeRange(secondDates)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};